<template>
    <v-container>
        <v-row>
            <v-col cols="12">
                <h3 class="text-center pt-5">Horarios de Atención</h3>
            </v-col>
            <v-col cols="12" sm="7">
                <div class="text-center my-5">
                    <span>(Editalos con un click)</span>
                </div>
                <v-simple-table class="mb-10">
                    <template v-slot:default>
                        <thead class="blue-grey darken-4">
                        <tr>
                            <th style="color:white" class="text-left">Dias</th>
                            <th style="color:white" class="text-left">Abierto desde</th>
                            <th style="color:white" class="text-left">Abierto hasta</th>
                            <th style="color:white" class="text-left">Estado</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item, index) in dataSchedules" :key="index">
                            <td>{{ item.day }}</td>
                            <td>
                                <span @click="showModal(index, 'open')" style="cursor: pointer">{{ item.open_hour.slice(0,5) }}</span>
                            </td>
                            <td>
                                <span @click="showModal(index, 'close')" style="cursor: pointer">{{ item.closed_hour.slice(0,5) }}</span>
                            </td>
                            <td>
                                <v-switch
                                    v-model="item.status"
                                    color="primary"
                                    :label="`${item.status ? 'Abierto' :'Cerrado'}`"
                                ></v-switch>
                            </td>
                        </tr>
                        </tbody>
                    </template>
                </v-simple-table>

                <div v-show="counterChanger > 1" class="text-center my-8">
                    <v-btn
                        @click="saveChanges"
                        color="primary"
                    >Guardar Cambios</v-btn>
                </div>
            </v-col>

            <v-col cols="12" sm="5">
                <div class="text-center my-5">
                    <span>Mensaje de cierre</span>
                </div>
                <v-card>
                    <v-card-text>
                        <v-text-field
                            label="Título"
                            dense
                            outlined
                            v-model="title"
                        ></v-text-field>
                        <v-textarea
                            label="Mensaje"
                            dense
                            outlined
                            v-model="message"
                        ></v-textarea>
                        <div class="text-center">
                            <v-btn
                                color="primary"
                                @click="saveMsgClosing"
                            >Guardar</v-btn>
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <v-dialog
            v-model="dialog"
            width="290"
            persistent
        >
            <v-row justify="center">
                <v-time-picker color="black" v-model="picker" format="24hr"></v-time-picker>
            </v-row>
            <v-spacer></v-spacer>
            <div class="text-center my-5">
                <v-btn color="black" outlined dark @click="dialog = false">Cancelar</v-btn>
                <v-btn color="gray darker-4" class="ml-3" dark @click="changeHour">Cambiar</v-btn>
            </div>
        </v-dialog>
    </v-container>
</template>
<script>
export default {
    data () {
        return {
            picker: null,
            dataSchedules: [],
            dialog: false,
            inModalHour: '',
            indexAux: -1,
            counterChanger: 0,
            // notifications
            title: 'Aviso!',
            message: 'En este instante está fuera de los horarios de atención, pero no se preocupe, puede programar su orden para otra hora o fecha.',
            type: 'closing'
        }
    },
    props: ['slug'],
    created() {
        this.timetables();
        this.getMainData()
    },
    methods: {
        async timetables() {
            await axios.post('/admin/get-schedules', {})
            .then((response) => {
                // console.log(response)
                this.dataSchedules = { ...response.data }
            })
            .catch((error) => {
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                }
            })
        },
        showModal (index, type) {
            this.dialog = true
            this.indexAux = index
            this.inModalHour = type

            if(type == 'open') {
                const hour = this.dataSchedules[index].open_hour
                this.picker = hour.slice(0,5)
                return
            }
            const hour = this.dataSchedules[index].closed_hour
            this.picker = hour.slice(0,5)
        },
        changeHour() {
            this.counterChanger++
            if(this.inModalHour == 'open') {
                this.dataSchedules[this.indexAux].open_hour = this.picker
                this.picker = ''
                this.dialog = false;
                return
            }
            this.dataSchedules[this.indexAux].closed_hour = this.picker
            this.picker = ''
            this.dialog = false;
        },
        async saveChanges() {
            await axios.post('/admin/update-schedules', {data: JSON.stringify(this.dataSchedules)})
            .then((response) => {
                // console.log(response)
                this.$notify.success("Se guardo con éxito")
                this.counterChanger = 1
            })
            .catch((error) => {
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                }
            })
        },
        // mensaje de cierre
        async getMainData() {
            await axios.get(`/data-order/${this.slug}`)
            .then((response) => {
                // console.log(response)
                if (response.data[9]) {
                    this.title = response.data[9].title
                    this.message = response.data[9].content
                }
            })
            .catch((error) => {
                // console.log(error)
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                }
            })
        },
        async saveMsgClosing() {
            this.loading8 = true
            const dataForm = new FormData()
            dataForm.append('owner', this.slug)
            dataForm.append('title', this.title)
            dataForm.append('content', this.message)
            dataForm.append('type', this.type)
            await axios.post(`/admin/save-datapost`, dataForm)
            .then((response) => {
                // console.log(response)
                if (response.data == 'ok') {
                    this.$alert('', 'Mensaje de aviso actualizado con éxito.', 'success', {confirmButtonText: 'Continuar'})
                    this.getMainData()
                }
                this.loading8 = false
            })
            .catch((error) => {
                // console.log(error)
                if (error.response.data.errors) {
                    this.errors = error.response.data.errors
                }
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                }
                this.loading8 = false
            })
        }
    },
    watch: {
        dataSchedules: {
            handler() {
                this.counterChanger++
            },
            deep: true
        }
    }
}
</script>

<style>
.v-dialog{
  background: #fff;
}
.v-picker{
  margin: 0 -12px 10px 12px !important;
}

.l-data-table{
  max-width: 600px;
  margin: 0 auto;
}

</style>
